//
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ModalDialog from 'app/components/organisms/ModalDialog/ModalDialog';
import { bind } from 'app/utils/decorators/decoratorUtils';
import { Button, Grid } from '@mic3/platform-ui';
import { closeSidebar } from 'store/actions/sidebar/sidebarActions';
import Loader from 'app/components/atoms/Loader/Loader';

import { removeCreatePinInteraction, removeLayer } from 'store/actions/maps/situationalAwarenessActions';
import { __getMapLayers } from 'app/utils/maps/layer/layerUtils';
import { saveComponentState } from 'store/actions/component/componentActions';

const DeleteButton = styled(Button)`
    &.MuiButton-textPrimary {
        color: ${({ theme }) => theme.material.colors.text.error} !important;
    }
`;

const StyledGrid = styled(Grid)`
    display: flex;
    color: ${({ color, theme }) => (theme && color ? 'white' : theme.base.textColor)};
`;

const StyledLayerTitle = styled.div`
    color: ${({ theme }) => theme.material.colors.text.primary} !important;
    margin-left: 4px;
`;

class RemoveLayerModal extends PureComponent {
    static propTypes = {
        deleteRelationship: PropTypes.func, 
        map: PropTypes.object.isRequired,
        mapId: PropTypes.string.isRequired,
        layer: PropTypes.object,
        closeModal: PropTypes.func,
        allMapLayers: PropTypes.array,
        removeCreatePinInteraction: PropTypes.func,
        removeLayer: PropTypes.func,
        closeSidebar: PropTypes.func,
        sidebarTitle: PropTypes.string, 
    };

    state = {
        isRemoving: false,
    };

    @bind
    async onLayerRemove({ id, title }) {
        this.setState({ isRemoving: true });
        const { map, layer: mapLayer, sidebarTitle } = this.props;
        if (!mapLayer?.id && !mapLayer?.name && !mapLayer?.title) {
            return;
        }
        
        const layer = map?.findLayerById(mapLayer?.id);
        
        const entityLayers = map.getEntityLayers?.() || {};
        let entityLayer = Object.values(entityLayers).find(layer =>
            layer?.info?.id === mapLayer?.id ||
            layer?.layerId === mapLayer?.id
        );
        if (!entityLayer) {
            entityLayer = Object.values(entityLayers).find(layer =>
                (mapLayer?.name && layer?.info?.name === mapLayer?.name) ||
                (mapLayer?.title && layer?.info?.title === mapLayer?.title) ||
                (mapLayer?.title && layer?.info?.layerTitle === mapLayer?.title)
            );
        }

        if (entityLayer) {
            if (typeof entityLayer.cleanup === 'function') {
                entityLayer.cleanup();
            }

            Object.keys(entityLayers).forEach(key => {
                if (entityLayers[key] === entityLayer) {
                    delete map.entityLayers[key];
                }
            });
        }
        
        if (layer?.getSource) {
            const layerSource = layer.getSource();
            layerSource?.clear && (await layerSource.clear());
        }
        layer && layer.unset('source');
        map.removeRelatedmapLayer(layer?.values_?.attributes?.id);
        const mapInstance = map.getMap();
        const entityLayerOL = entityLayer?.getLayer?.();
        if (mapInstance.removeLayer) {
            await mapInstance.removeLayer(layer);
            entityLayerOL && mapInstance.removeLayer(entityLayerOL);
        }
        mapInstance && (await mapInstance.updateSize());
        if (layer) {
            this.props.removeCreatePinInteraction();
            this.props.removeLayer(mapLayer);
        }
        
        this.setState({ isRemoving: false }, () => {
            this.props.closeModal();
            sidebarTitle !== 'Layers' && this.props.closeSidebar(); 
        });
        map && map.removeHightLightFeatures();
    }

    render() {
        const { layer, allMapLayers } = this.props;
        const foundLayer = allMapLayers?.find(lyr => lyr?.id === layer?.id);
        const { isRemoving } = this.state;
        return (
            <ModalDialog withoutClose={true} title={'Remove Layer'} maxWidth={'sm'}>
                <StyledGrid>
                    {`Are you sure you want to delete layer `}
                    <StyledLayerTitle> {foundLayer?.name || foundLayer?.title} </StyledLayerTitle> {'?'}
                </StyledGrid>
                <StyledGrid>{'This action cannot be undone.'}</StyledGrid>
                <Grid item container xs={12} justify="flex-end" alignItems="flex-end" alignContent="flex-end">
                    <Button onClick={this.props.closeModal} variant="text">
                        CANCEL
                    </Button>
                    <DeleteButton onClick={this.onLayerRemove} variant="text" disabled={isRemoving}>
                        {isRemoving ? <Loader size={20} /> : 'DELETE'}
                    </DeleteButton>
                </Grid>
            </ModalDialog>
        );
    }
}

export default connect(
    state => ({
        allMapLayers: __getMapLayers(state.maps.situationalAwareness.map.data),
        sidebarTitle: state.sidebar.title,
    }),
    {
        closeSidebar,
        removeCreatePinInteraction,
        saveComponentState,
        removeLayer,
    }
)(RemoveLayerModal);
